var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "bounce" } }, [
    this.$store.state.alert_bar_closed != true &&
    (_vm.parsedLink || _vm.alert_banner_text)
      ? _c("div", { staticClass: "alert_banner" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "inner" }, [
              _vm.alert_banner_text
                ? _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.alert_banner_text) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.parsedLink
                ? _c("a", {
                    attrs: {
                      href: _vm.parsedLink.url,
                      target: _vm.parsedLink.target,
                    },
                    domProps: { innerHTML: _vm._s(_vm.parsedLink.title) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "close_image",
                  on: { click: _vm.closeAlertBar },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 18 18",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M8.70703 10.1213L15.9998 17.4141L17.4141 15.9999L10.1212 8.70709L17.4142 1.41412L16 -9.15527e-05L8.70703 7.29288L1.41406 -9.15527e-05L-0.000152588 1.41412L7.29282 8.70709L0 15.9999L1.41421 17.4141L8.70703 10.1213Z",
                          fill: "#203136",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }